import React from 'react';

import { Field, Form } from 'react-final-form';

import { Button, Card, Text } from '@change/ds-core-ui';
import { TextField } from '@change/ds-forms';

import { Translate } from '@change-corgi/core/react/i18n';

import type { MediaHitValues } from '../../shared/context/types';

import { MediaSubmitMessages } from './components/MediaHitSubmitMessages';
import { useAddMediaHit } from './hooks/useAddMediaLinks';

export function AddMediaHit(): React.JSX.Element | null {
	const {
		data: { loading },
		actions: { validateLink, handleSubmitMediaHit: handleSubmitMediaLink },
	} = useAddMediaHit();

	return (
		<>
			<Card data-testid="add-media-wrapper" className="bg-background-base mt-[52px] rounded-lg p-4">
				<Text variant="heading" as="h3" size="x-small" className="mb-2">
					<Translate value="corgi.petition_gamma.media_mentions.add.title" />
				</Text>
				<Text variant="body" size="small" className="mb-2 whitespace-pre-line">
					<Translate value="corgi.petition_gamma.media_mentions.add.description" />
				</Text>
				{/* eslint-disable-next-line @change-corgi/require-data-qa-attribute */}
				<Form<MediaHitValues>
					onSubmit={handleSubmitMediaLink}
					initialValues={{ link: '' }}
					subscription={{ pristine: true, submitting: true, submitFailed: true }}
				>
					{({ handleSubmit }) => (
						<form onSubmit={handleSubmit} data-qa="add-media-form">
							<div className="mb-2 flex flex-col items-start gap-4 lg:flex-row">
								<div className="w-full lg:w-[60%]">
									<Field<string> name="link" type="text" validate={validateLink}>
										{({ input, meta }) => {
											const shouldShowError = (meta.touched || meta.submitFailed) && !!meta.error;
											return (
												<TextField
													id="add-media-link"
													label="Media URL"
													labelIsVisible={false}
													name={input.name}
													value={input.value}
													onChange={input.onChange}
													onBlur={input.onBlur}
													placeholder="https://www.link.com"
													data-testid="add-media-link-input"
													data-qa="add-media-link-input"
													className="w-full"
													isInvalid={shouldShowError}
													inputOptions={{
														type: 'text',
														className: 'h-11 bg-background-base',
													}}
													errorMessage={shouldShowError && typeof meta.error === 'string' ? meta.error : undefined}
												/>
											);
										}}
									</Field>
								</div>
								<Button
									variant="secondary"
									type="submit"
									data-testid="add-media-link-button"
									data-qa="add-media-link-button"
									disabled={loading}
									className="h-11 w-full lg:w-[40%]"
								>
									<Translate value="corgi.petition_gamma.media_mentions.add.action" />
								</Button>
							</div>
						</form>
					)}
				</Form>
			</Card>

			<MediaSubmitMessages />
		</>
	);
}
